import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { HiveObjectDataset } from 'app/model/dataset/hive.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HiveObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class HiveObjectDatasetAdapter extends TabularTypeDatasetAdapter<HiveObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: HiveObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(HiveObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: HiveObjectDataset): Promise<HiveObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, HiveObjectDataset.MODEL);
    }
}
